/* eslint-disable */
<template>
  <!-- ################# TOP NAV ################### -->
    <div class="container-fluid bg-dark header-top d-none d-md-block">
      <div class="container">
        <div class="container-top text-light pt-2 pb-2">
          <div class="">
            <i class="fa fa-envelope-o mr-2" aria-hidden="true"></i>mbclothing@gmail.com
          </div>
          <div class="">
            <i class="fa fa-phone mr-2" aria-hidden="true"></i>+2349059053779
            <i class="fa fa-map-marker ml-5 mr-2" aria-hidden="true"></i>Lagos, Nigeria
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "TopNav"
};
</script>

<style></style>
